var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7578 34.2168C9.86281 34.2168 2.63281 26.9868 2.63281 18.0918C2.63281 9.1968 9.86281 1.9668 18.7578 1.9668C27.6528 1.9668 34.8828 9.1968 34.8828 18.0918C34.8828 26.9868 27.6528 34.2168 18.7578 34.2168ZM18.7578 4.2168C11.1078 4.2168 4.88281 10.4418 4.88281 18.0918C4.88281 25.7418 11.1078 31.9668 18.7578 31.9668C26.4078 31.9668 32.6328 25.7418 32.6328 18.0918C32.6328 10.4418 26.4078 4.2168 18.7578 4.2168Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3222 23.9868C24.1272 23.9868 23.9322 23.9418 23.7522 23.8218L19.1022 21.0468C17.9472 20.3568 17.0922 18.8418 17.0922 17.5068V11.3568C17.0922 10.7418 17.6022 10.2318 18.2172 10.2318C18.8322 10.2318 19.3422 10.7418 19.3422 11.3568V17.5068C19.3422 18.0468 19.7922 18.8418 20.2572 19.1118L24.9072 21.8868C25.4472 22.2018 25.6122 22.8918 25.2972 23.4318C25.0722 23.7918 24.6972 23.9868 24.3222 23.9868Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.888de4f404acf1f7e82536f6d4cfc450.svg";
export { ForwardRef as ReactComponent };